import React, { useState, useEffect } from 'react';

const QTYSmallBasket = ({
    qty: initialQty = 1,
    minQty = 1,
    maxQty = 10,
    steps = 1,
    isReadOnly = false,  // این برای غیرفعال کردن کل کامپوننت موقع لودینگ
    pageLanguage,
    NumberToPersianWord,
    onIncrement,
    onDecrement,
    onInputChange,
    isLoading = false  // پراپ جدید برای لودینگ
}) => {
    
    const [internalQty, setInternalQty] = useState(initialQty);
    
    useEffect(() => {
        setInternalQty(initialQty);
    }, [initialQty]);
    
    const handleIncrement = () => {
     
     if (isLoading) {
         return;
     }
     if (internalQty < maxQty && onIncrement) {
         onIncrement();
     }
    };
    
    const handleDecrement = () => {
        if (isLoading) return;  // اگه لودینگ هست، هیچ کاری نکن
        if (internalQty > minQty && onDecrement) {
            onDecrement();
        }
    };
    
    const handleInputChange = (e) => {
        if (isLoading) return;  // اگه لودینگ هست، هیچ کاری نکن
        let value = NumberToPersianWord.convertPeToEn(e.target.value);
        value = parseInt(value, 10);
        
        if (isNaN(value)) return;
        if (value < minQty) value = minQty;
        if (value > maxQty) value = maxQty;
        
        if (onInputChange) onInputChange(value);
    };
    
    const formatQuantity = () => {
        return pageLanguage === "fa"
            ? NumberToPersianWord.convertEnToPe(`${internalQty}`)
            : internalQty;
    };
    
    return (
        <div className="basket_item_qty_numbers" style={{ opacity: isLoading ? 0.6 : 1 }}>
            <button
                type="button"
                className="basket_qty_minus"
                onClick={handleDecrement}
                disabled={isLoading || internalQty <= minQty}
            >
                <img
                    src={require('../Images/public/minus.svg').default}
                    alt=""
                    className="qty_math_icon img-fluid"
                />
            </button>
            <input
                type="text"
                className="basket_qty_num"
                value={formatQuantity()}
                onChange={handleInputChange}
                readOnly={isReadOnly || isLoading}
                style={{ backgroundColor: isLoading ? '#f0f0f0' : 'white' }}
            />
            <button
                type="button"
                className="basket_qty_plus"
                onClick={handleIncrement}
                disabled={isLoading || internalQty >= maxQty}
            >
                <img
                    src={require('../Images/public/plus.svg').default}
                    alt=""
                    className="qty_math_icon img-fluid"
                />
            </button>
        </div>
    );
};

export default QTYSmallBasket;